import React, { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { LoaderOverlayProvider } from './components/Loader';
import ApiProvider from './api/ApiProvider';
import CookieLayer from './components/CookieLayer/CookieLayer';
import router from './routing/Routes';

import './bootstrap.css';
import './sass/style.scss';
import keyboardFocus from 'keyboard-focus';

const cookieAccepted = window.localStorage.getItem('cookieAccepted');

export default () => {
  keyboardFocus(document);
  const [showCookie, setShowCookie] = useState(!cookieAccepted);

  document.body.style.overflow = showCookie ? 'hidden' : 'auto';

  return (
    <LoaderOverlayProvider>
      <ApiProvider>
        {showCookie && <CookieLayer setShowCookie={setShowCookie} />}
        <RouterProvider router={router} />
      </ApiProvider>
    </LoaderOverlayProvider>
  );
};
